module.exports = __webpack_public_path__ + "img/Bodice-Front-B7-Da-Eb.fe9cfe03.png";